import type { HelpFile } from '../../types/help'
import { PreviewResultDialogTestIds } from '../../../testids/PreviewResultDialogTestIds'

export const previewResultDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [PreviewResultDialogTestIds.previewResultDialog]:
      'Rohantwort des Quellsystems, die während eines Vorschau-Laufs erfasst wurde — nützlich, um Zuordnungen zu prüfen, bevor eine vollständige Synchronisation ausgelöst wird.',
    [PreviewResultDialogTestIds.previewBody]: null,
    [PreviewResultDialogTestIds.previewEmpty]: null,
    [PreviewResultDialogTestIds.previewLoading]: null,
    [PreviewResultDialogTestIds.btnClosePreview]: null,
    [PreviewResultDialogTestIds.btnDownloadPreview]:
      'Die erfasste Antwort als Datei zur Offline-Analyse herunterladen.',
  },
}
